import React from 'react';
import '../styles/meetleader.css';
import leader from '../assets/co6-leader.png';
import AnimatedArrowButton from './AnimatedArrowButton';


const MeetLeader = () => {


    return(
    <div className='meetleader'>
        <h4 style={{marginTop:'1.5rem',marginBottom:'1.6rem' , textAlign:'center',color:'#FFD52B',fontSize:'1.2rem'}}>Meet Our Leaders</h4>
        <hr></hr>
        <div style={{padding:"2rem"}}>
        <h1 style={{textAlign:'center',color:'white',fontSize:'2.6rem',fontWeight:'700'}}>Behind Every Innovation is a Visionary Team</h1>
        
        <div className='meetleader-container' style={{display:'flex', marginTop:'3rem'}}>
            <div className='meetleader-box1'>
                <img className='leader-pic' src={leader} width='70%' height='100%' style={{objectFit:'cover',borderRadius:'5px',objectPosition:'top'}}></img>
            </div>
            <div className='meetleader-box2' style={{position:'relative'}}>
            <h6>Mohamed Jahangir Ghouse</h6>
            <p style={{fontSize:'0.8rem',color:'#FFD52B'}}>Managing Director</p>
            <p style={{color:'white'}}>A pioneer in robotics and automation, Jahangir has built CO6 into a global leader with a commitment to innovation and quality. His vision is to seamlessly integrate robotics into every facet of industry and daily life.</p>
            <h6>Quote</h6>
            <p style={{fontSize:'0.9rem',color:'#FFD52B',fontStyle:'italic'}}>“The future of work is a productive interplay<br></br> between humans and robots.”</p>
            <div className='meetleader-button' style={{position:'absolute', bottom:'2rem',right:'1.5rem'}}><AnimatedArrowButton  text="Learn More" link="/Robotics-Team"   /></div>
            </div>
        </div>
        </div>

    </div>);


}

export default MeetLeader;